var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('nuxt-link',{attrs:{"to":_vm.$storyblok.storyUrl(item.link.uuid),"title":item.link.name}},[_vm._v("\n\t\t\t"+_vm._s(item.link.name)+"\n\t\t")]),_vm._v(" "),_c('Tree',{attrs:{"items":item.children}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }